<template>
  <div class="document-template-management">
    <document-template-tree-grid
      v-show="view==='list'"
      ref="documentTemplateTreeGrid"
      style="height: 100%"
      :context="context"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @refresh="refreshHandle"
    />
    <document-template-workspace
      v-show="view==='detail'"
      ref="documentTemplateWorkspace"
      style="height: 100%"
      :parent-context="context"
      @add="addHandle"
      @edit="editHandle"
      @look="lookHandle"
      @back="backToList"
      @refresh="refreshHandle"
    />
  </div>
</template>

<script>
import DocumentTemplateTreeGrid from './components/DocumentTemplateTreeGrid'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import DocumentTemplateWorkspace from '@/views/cargo/v0/SystemMaintenance/documentTemplateManagement/components/DocumentTemplateWorkspace.vue'
import { BookingNewContext } from '@/views/cargo/v0/SeaExport/bookingNewContext'

export default {
  name: 'DocumentTemplateManagement',
  components: { DocumentTemplateWorkspace, DocumentTemplateTreeGrid, jobNoRuleSelector, cargoTemplateSelectorDialog },
  props: {
  },
  data() {
    return {
      context: BookingNewContext.getInstance(),
      view: 'list'
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    office() {
      return this.context.office
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  created() {
    this.context.prepareData()
  },
  methods: {
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    editHandle(row) {
      this.detailHandle('edit', row)
    },
    addHandle() {
      this.detailHandle('add', { uuid: '' })
    },
    backToList(isRefresh) {
      const rowData = this.$refs.documentTemplateWorkspace.rowData
      this.view = 'list'
      if (!isRefresh) {
        this.$refs.documentTemplateTreeGrid.toQuery(rowData)
      } else {
        this.$refs.documentTemplateTreeGrid.updateListData(rowData)
      }
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.documentTemplateWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.documentTemplateTreeGrid.rowData
      }
      this.$refs.documentTemplateWorkspace.onShow(type, rowData, row)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    // 操作成功后刷新详情
    refreshHandle(row) {
      this.detailHandle('look', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.document-template-management{
  height: 100%;
}
</style>
